/* eslint-disable no-console */
import {
    register
} from 'register-service-worker'

/** Minimum time between SW update checks triggered by route changes (ms). Tune here only. */
const SW_UPDATE_CHECK_MIN_INTERVAL_MS = 5 * 60 * 1000 // 5 minutes

let lastSwUpdateCheckAt = 0

/**
 * Ask the browser to check for a new service worker (e.g. after SPA route changes,
 * since there is no full page load). If a new worker is found, register-service-worker
 * will fire `updated` and the app can show the reload banner.
 * Throttled so frequent navigations do not call `getRegistration` / `update` every time.
 */
export function checkForServiceWorkerUpdate() {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
        return
    }
    const now = Date.now()
    if (now - lastSwUpdateCheckAt < SW_UPDATE_CHECK_MIN_INTERVAL_MS) {
        return
    }
    lastSwUpdateCheckAt = now
    navigator.serviceWorker.getRegistration().then((reg) => {
        if (reg) {
            return reg.update()
        }
        return undefined
    }).catch(() => {
        /* ignore (e.g. dev / unsupported) */
    })
}

export function registerServiceWorker() {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            console.log('App is being served from cache by a service worker.')
        },
        registered() {
            console.log('Service worker has been registered.')
        },
        cached() {
            console.log('Content has been cached for offline use.')
        },
        updatefound() {
            console.log('New content is downloading.')
        },
        updated(registration) {
            window.dispatchEvent(
                new CustomEvent('swUpdated', {
                    detail: registration
                })
            )
        },
        offline() {
            console.log('No internet connection found. App is running in offline mode.')
        },
        error(error) {
            console.error('Error during service worker registration:', error)
        }
    })
}
